<template>
  <div>
    <v-select v-if="allItems && allItems.length > 0"
      multiple
      label="Title"
      :closeOnSelect="false"
      v-model="selectedItemsInput"
      taggable
      push-tags
      :options="allItems"
      @option:created="commitNewItems"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import TagsService from "@/tags/tagsService.js";

export default {
  data() {
    return {
      allItems: [],
    };
  },
  mounted() {
    var instance = this;
    if (this.GetItemsPromise) {
      this.GetItemsPromise().then(function (response) {
        instance.$set(instance, "allItems", response.data);
      });
    }
  },
  methods: {
    commitNewItems: function (newVal) {
      var instance = this;

      this.commitItemsPromise([
        {
          Title: newVal.Title,
        },
      ]).then(function (response) {
        var lastItem = instance.selectedItemsInput.filter(
          (item) => !item.Id || item.Id < 1
        );
        if (lastItem && lastItem.length > 0) {
          lastItem[0] = response.data[0];
        }

        var allItems = instance.allItems;

        var itemsUpdated = instance.selectedItemsInput;
        var itemsWithoutThisOne = instance.selectedItemsInput.filter(item => item.Id && item.Id > 0);
        itemsWithoutThisOne.push(lastItem[0]);
        instance.$set(instance, "selectedItemsInput", itemsWithoutThisOne);
      });
    },
  },
  props: [
    "selectedItems",
    "isEditing",
    "items",
    "RelatedParentType",
    "RelatedItemsType",
    "GetItemsPromise",
    "commitItemsPromise",
    "RelatedParentId",
  ],
  computed: {
    selectedItemsInput: {
      get: function () {
        return this.selectedItems ? this.selectedItems.filter(itm => itm != null && itm.Item != null).map((itm) => itm.Item) : [];
      },
      set: function (newValue) {
        var filtered = this.selectedItems.filter(
          (f) => f.Item != null && newValue.filter((v) => v.Id == f.Item.Id).length > 0
        );
        var newItems = newValue.filter(
          (newItem) =>
            this.selectedItems.filter((si) => si.Item != null && si.Item.Id == newItem.Id) == 0
        );
        var instance = this;

        newItems.forEach((element) => {
          filtered.push({
            Id: -1,
            Item: element,
            RelatedObjectId: instance.RelatedParentId,
            TargetRelationId: element.Id,
            RelatedObjectName: instance.RelatedParentType,
            TargetRelationName: instance.RelatedItemsType,
          });
        });

        this.$emit("update:selectedItems", filtered);
      },
    },
  },
  components: {
    vSelect,
  },
};
</script>
